export * from "./language-selector-banner";
export { LanguageSelectorBanner as default } from "./language-selector-banner";
